'use client';

import { TheBoatAppLandingConfigType, useConfig } from '@marine/configs';
import { FC } from 'react';
import { SanityImage } from 'sanity-image';

type Props = {
  imageId: string;
  altText: string;
};

const RecentPostImage: FC<Props> = ({ imageId, altText }) => {
  const { projectId, dataset } = useConfig<TheBoatAppLandingConfigType>();

  return <SanityImage id={imageId} projectId={projectId} dataset={dataset} width={64} height={64} alt={altText} />;
};

export { RecentPostImage };
